import React, { memo } from "react";
import * as PropTypes from "prop-types";
import PivotTable from "../../table/PivotTable";

const ProjectedFundingGapsWithinPublicSectorTable = props => (
  <PivotTable
    reference="1.3"
    caption="Projected Funding Gaps Within Public Sector, 2020 and 2025"
    subcaption="Within Private Sector"
    titles={[
      {
        title: "",
        columnSpan: 1
      },
      {
        title: "Donors",
        columnSpan: 3,
        groupStart: true
      },
      {
        title: "Government",
        columnSpan: 3,
        groupStart: true
      }
    ]}
    columnKey="indicator"
    columnDefinitions={[
      {
        value: "Spend (Donor)",
        label: "Spending",
        groupStart: true
      },
      {
        value: "Cost Share (Donor)",
        label: "Cost Share"
      },
      {
        value: "Gap (Donor)",
        label: "Gap"
      },
      {
        value: "Spend (Government)",
        label: "Spending",
        groupStart: true
      },
      {
        value: "Cost Share (Government)",
        label: "Cost Share"
      },
      {
        value: "Gap (Government)",
        label: "Gap"
      }
    ]}
    rowKey="year"
    rowDefinitions={[
      {
        value: "Current",
        current: true
      },
      {
        value: "2020"
      },
      {
        value: "2025"
      },
      {
        value: "Change (#)"
      },
      {
        value: "Change (%)",
        percentage: true
      },
      {
        value: "Cumulative (5 yr)"
      }
    ]}
    data={props.data}
    na="&#8212;"
  />
);

ProjectedFundingGapsWithinPublicSectorTable.propTypes = {
  data: PropTypes.array.isRequired,
  areaId: PropTypes.number.isRequired
};

export default memo(ProjectedFundingGapsWithinPublicSectorTable);
